import { Box, Button, Dialog, DialogContent, DialogTitle, Divider, Grid, Paper, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { buttonStyle, errorTextStyle, titleStyle } from '../../../utils/commonCSS'
import { checkAllVotersVoted, generateElectionResult, getCandidateAndVoterList } from '../../../backend/backendApis'
import HttpService from '../../../backend/requestApis'
import CustomPieChart from '../../CustomComponents/CustomPieChart'
import { headingBlue, maroon, mediumGrey, orange, textGeen } from '../../../assets/colors'
import { useNavigate } from 'react-router-dom'
import Loader from '../../Loader'
import { ArrowLeft, ArrowRight, Download } from '@mui/icons-material'
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver'

const ElectionResult = (props) => {

    console.log('Props: ', props)

    const [votingStats, setVotingStats] = useState({})
    const [pieData, setPieData] = useState({})
    const [generateResultSatus, setGenerateResultStatus] = useState(false)
    const [electionResut, setElectionResult] = useState([])
    const [resultGenerated, setResultGenerated] = useState(false)
    const [CDList, setCDList] = useState([])
    const [VLList, setVLList] = useState([])
    const [confirmDialogStatus, setConfirmDialogStatus] = useState(false)

    const [isLoading, setIsLoading] = useState(false)
    const [apiError, setApiError] = useState('')

    const navigate = useNavigate()

    const handleGenerateResult = () => {
        setIsLoading(() => true)
        let options= {
            url: generateElectionResult + `/${props?.data?._id}`,
            method: 'POST',
            payload:{},
            headers: {
                headers:{
                    Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : null
                }
            }
        }

        HttpService(options).then(resp =>{
            setElectionResult(resp?.data?.data)
            setConfirmDialogStatus(() => false)
            // setResultGenerated(true)
            setIsLoading(() => false)
            props.updateDialogStatus(false, true)
        }).catch(err =>{
             if( err?.status === 403){
                localStorage.clear()
                navigate('/Login')
            } else {
                console.log("Error in Generating Result: ", err)
                setApiError(err?.response?.data?.message || 'Internal Server Error. Please Contact Support.')
            }
        })
    }

    useEffect(() => {
        if( props?.dialoagStatus){
            setIsLoading(true)
            let options = {
                url: checkAllVotersVoted + `/${props?.data?._id}`,
                method: 'GET',
                params: {},
                headers: {
                    Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : null
                }
            }
            HttpService(options).then((resp) => {
                let result = resp?.data?.data
                setVotingStats(resp?.data?.data)
                if(result['votersNotVotedCount'] === 0 ){
                    setGenerateResultStatus(() => true)
                }
                let pieData = {
                    title: "",
                    totalVotes: result['totalVotersCount'],
                    series: [
                        {name: 'Votes', y: result['totalVotersCount'] - result['votersNotVotedCount'], color: orange},
                        {name: 'Remaining', y: result['votersNotVotedCount'], color: '#D3D3D3'}
                    ]
                }
                setPieData(() => pieData)
                setIsLoading(() => false)
            }).catch(err => {
                 if( err?.status === 403){
                    localStorage.clear()
                    navigate('/Login')
                } else {
                    console.log("Error in checking Voters voted Status: ", err)
                    setApiError(err?.response?.data?.message || 'Internal Server Error. Please Contact Support.')
                }
            })
        }
    }, [props.dialoagStatus])

    useEffect(() => {
        if( props?.dialoagStatus){
            setIsLoading(() => true)
            let options = {
                url: getCandidateAndVoterList + `/${props?.data?._id}`,
                method:"GET",
                params: {},
                headers: {
                    Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : null
                }
            }
            HttpService(options).then((resp) => {
                setCDList(() =>  resp?.data?.data?.candidateList)
                setVLList(() => resp?.data?.data?.voterList)
                setIsLoading(() => false)
                
            }).catch(err => {
                if( err?.status === 403){
                    localStorage.clear()
                    setIsLoading(false)
                    navigate('/Login')
                } else {
                    console.log('Error in fetching Candidate and Voters List ', err)
                    setApiError(err?.response?.data?.message)
                    setIsLoading(false)
                }
            })
        }

    }, [props.dialoagStatus])

    useEffect(() => {
        setApiError('')
        setGenerateResultStatus(() => false)
        if(props?.dialoagStatus && props?.data?.electionStatus === 'close'){
            setResultGenerated(() => true)
            setElectionResult(props?.data?.electionResult)
        } else {
            setResultGenerated(() => false)
            setElectionResult(() => [])
        }
    }, [props?.dialoagStatus])

    const handleDownload = (title, data) => {
        var columnMapping = {
            name: 'WORKer',
            contactNumber: 'Contact Number'
        }

        if(title === 'Voter Not Voted'){
            columnMapping = {
                voterName: 'WORKer',
                voterCN: 'Contact Number'
            }
        }
        const transformedData = data.map(row => {
            const transformedRow = {}
            Object.keys(row).sort((a,b) => b.localeCompare(a)).forEach(key => {
                if(columnMapping[key]){
                    transformedRow[columnMapping[key]] = row[key]
                }
            })
            return transformedRow
        })

        const workBook = XLSX.utils.book_new();
        const workSheet = XLSX.utils.json_to_sheet(transformedData)
        XLSX.utils.book_append_sheet(workBook, workSheet, 'Sheet 1')
        const excelBuffer = XLSX.write(workBook, {bookType: "xlsx", type: 'array'})
        const blob = new Blob([excelBuffer], {type: 'application/octet-stream'})
        saveAs(blob, `${title}.xlsx`)
    }


    const otherDetailsTable = (title, data, stats= false) => {
        return <>
            <Grid item xs={3.9} sm={3.9} style={{ padding: '1rem 0.5rem 1rem 0.5rem'}}>
                <Paper style={{height: '100%', padding: '1rem 0.5rem 1rem 0.5rem', border: `1px solid #D3D3D3`}}>
                    <Box style={{display: 'flex', justifyContent: 'space-between', width: '100%', padding: '0rem 0rem 0.5rem 0rem'}}>
                        <Typography style={{color: headingBlue, fontSize: '1.2rem'}}><strong>{title}</strong></Typography>
                        {/* <Box style={{width: '50%', display: 'flex', justifyContent: 'flex-end'}}>
                            <ArrowLeft style={{color: headingBlue}}></ArrowLeft>
                            <Typography>{0}</Typography>
                            <ArrowRight style={{color: headingBlue}}></ArrowRight>
                            
                        </Box> */}
                        <Download style={{color: headingBlue}}
                            onClick = {async () => {
                                await handleDownload(title, data)
                            }}
                        ></Download>
                    </Box>
                    
                    {stats &&
                        <Box style={{width: '100%', display: 'flex', justifyContent: 'center', padding: '0.1rem 0.2rem 1rem 0.2rem'}}>
                            <Typography style={{fontSize: '3rem', color: maroon}}> {`${votingStats?.votersNotVotedCount || 0}/${votingStats?.totalVotersCount || 0}`}</Typography>
                        </Box>
                    }
                    
                    {data?.map((ele) => (
                        <>
                            <Grid container spacing={1} style={{padding: '0.1rem 0rem 0.1rem 0rem'}}>
                                <Grid item xs={8} sm={8} style={{borderBottom: `1px solid #D3D3D3`}}>
                                    <Typography>{ele?.voterName || ele?.name}</Typography>
                                </Grid>
                                <Grid item xs={4} sm={4} style={{borderBottom: `1px solid #D3D3D3`}}>
                                    <Typography>{ele?.voterCN || ele?.contactNumber}</Typography>
                                </Grid>
                            </Grid>
                        </>
                    ))}


                </Paper>
            </Grid>
        </>
    }

  return (
    <>
        <Dialog maxWidth = 'lg' fullWidth open={props?.dialoagStatus} onClose={() => props.updateDialogStatus()}>
            <DialogTitle style={{...titleStyle, fontSize: '1.2rem'}}>
                ElectionResult
            </DialogTitle>
            <DialogContent>
                {isLoading && <Loader></Loader>}
                <Grid container spacing={0} gap={1} style={{padding: '1rem 0.5rem 1rem 0.5rem'}}>
                    
                    <Grid item xs={3.0} sm={3.9} style={{display: 'flex', justifyContent: 'flex-end', width:'100%'}}>
                        {/* <Paper style={{height: '100%', padding: '1rem 0.5rem 1rem 0.5rem', border: `1px solid #D3D3D3`}}> */}
                            <CustomPieChart mode='Percent' data={pieData}></CustomPieChart>
                        {/* </Paper> */}
                        
                    </Grid>
                    <Grid item xs={3.9} sm={3.9} style={{ padding: '1rem 0.5rem 1rem 0.5rem'}}>
                        <Paper style={{height: '100%', padding: '1rem 0.5rem 1rem 0.5rem', border: `1px solid #D3D3D3`}}>
                            <Box style={{}}>
                                <Typography style={{color: headingBlue, fontSize: '1.2rem'}}><strong>Election Details</strong></Typography>
                            </Box>
                            
                            <Box style={{width: '100%', display: 'flex', justifyContent: 'center', padding: '1rem 0.2rem 1rem 0.2rem'}}>
                                {/* <Typography style={{fontSize: '3rem', color: maroon}}> {`${votingStats?.votersNotVotedCount}/${votingStats?.totalVotersCount}`}</Typography> */}
                                <Grid container spacing={1}>
                                    <Grid item xs={4} sm={4} style={{borderRight: '1px solid #D3D3D3', borderBottom: '1px solid #D3D3D3'}}>
                                        <Typography>Name</Typography>
                                    </Grid>
                                    <Grid item xs={8} sm={8} style={{ borderBottom: '1px solid #D3D3D3'}}>
                                        <Typography>{ props?.data?.programName}</Typography>
                                    </Grid>
                                    <Grid item xs={4} sm={4} style={{borderRight: '1px solid #D3D3D3', borderBottom: '1px solid #D3D3D3'}}>
                                        <Typography>Date</Typography>
                                    </Grid>
                                    <Grid item xs={8} sm={8} style={{borderBottom: '1px solid #D3D3D3'}}>
                                        <Typography>{props?.data?.programDate?.split('T')[0] || '-' }</Typography>
                                    </Grid>
                                    <Grid item xs={4} sm={4} style={{borderRight: '1px solid #D3D3D3' , borderBottom: '1px solid #D3D3D3'}}>
                                        <Typography>Posts</Typography>
                                    </Grid>
                                    <Grid item xs={8} sm={8} style={{borderBottom: '1px solid #D3D3D3'}}>
                                        <Typography>{props?.data?.numOfPosts || '-' }</Typography>
                                    </Grid>
                                    <Grid item xs={4} sm={4} style={{borderRight: '1px solid #D3D3D3', borderBottom: '1px solid #D3D3D3'}}>
                                        <Typography>Status</Typography>
                                    </Grid>
                                    <Grid item xs={8} sm={8} style={{borderBottom: '1px solid #D3D3D3'}}>
                                        <Typography>{props?.data?.electionStatus ? props.data.electionStatus === "open" ? 'Open' : props.data.electionStatus === 'close' ? 'Close' : '-' : '-' }</Typography>
                                    </Grid>

                                </Grid>
                            </Box>
                        </Paper>
                    </Grid>
                    {otherDetailsTable('Election Commision List', props?.data?.electionCommisionsList)}
                    {otherDetailsTable('Voter Not Voted', votingStats?.votersNotVoted, true)}                    
                    {otherDetailsTable('Candidates Lists', CDList)}
                    {otherDetailsTable('Voters Lists', VLList)}
                    
                    

                </Grid>

                {!resultGenerated && 
                    <Box style={{display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', marginTop: '5rem', marginBottom: '3rem'}}>
                        <Button style={{...buttonStyle, fontSize: '1.3rem', 
                            pointerEvents: props?.data?.isActive ? 'auto' : 'none',
                            opacity: props?.data?.isActive ? 1 : 0.5    
                        }} onClick={() => {
                            // handleGenerateResult()
                            generateResultSatus ? handleGenerateResult() :
                            setConfirmDialogStatus(() => true)
                        }}>Generate Result</Button>
                    </Box>
                }

                {resultGenerated && 
                    <>
                        <Box style={{ width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', marginTop: '1.5rem'}}>
                            <Box style={{}}>
                                <Typography style={{fontSize: '1.2rem', color: headingBlue}}><strong>Result</strong></Typography>
                            </Box>
                            <Box style={{}}>
                                <Grid container spacing={1} style={{padding: '0.5rem 0.5rem 1rem 0.5rem'}}>
                                    <Grid item xs={1} sm={1} style={{borderBottom: `1px solid #D3D3D3`}}>
                                        S.No
                                    </Grid>
                                    <Grid item xs={3} sm={3} style={{borderBottom: `1px solid #D3D3D3`}}>
                                        Candidate Name
                                    </Grid>
                                    <Grid item xs={3} sm={3} style={{borderBottom: `1px solid #D3D3D3`}}>
                                        Candidate Contact Number
                                    </Grid>
                                    <Grid item xs={1} sm={1} style={{borderBottom: `1px solid #D3D3D3`}}>
                                        Rank
                                    </Grid>

                                </Grid>
                                {
                                    electionResut?.map((cand, index) => (
                                            <>
                                                <Grid container spacing={1} style={{padding: '0.5rem 0.5rem 1rem 0.5rem'}}>
                                                    <Grid item xs={1} sm={1} style={{borderBottom: `1px solid #D3D3D3`}}>
                                                        {index + 1}
                                                    </Grid>
                                                    <Grid item xs={3} sm={3} style={{borderBottom: `1px solid #D3D3D3`}}>
                                                        {cand?.candidateName}
                                                    </Grid>
                                                    <Grid item xs={3} sm={3} style={{borderBottom: `1px solid #D3D3D3`}}>
                                                        {cand?.candidateCN}
                                                    </Grid>
                                                    <Grid item xs={1} sm={1} style={{borderBottom: `1px solid #D3D3D3`}}>
                                                        {cand?.rank}
                                                    </Grid>

                                                </Grid>
                                            </>
                                    ))
                                }
                            </Box>
                            
                        </Box>
                    </>
                }
                <Box style={{display: 'flex', width: '98%', padding: '0.5rem'}}>
                    <Typography style={{...errorTextStyle}}>{apiError}</Typography>
                </Box>

                <>
                    <Dialog maxWidth='sm' fullWidth open={confirmDialogStatus} onClose={() => {setConfirmDialogStatus(() =>  false)}}>
                        <DialogTitle style={{...titleStyle, fontSize: '1.2rem', padding: '0.5rem 0.2rem 0.5rem 0.75rem'}}> Confirm</DialogTitle>
                        <DialogContent style={{padding: '0.75rem', marginTop: '0rem'}}>
                            <Typography style={{fontSize: '1.1rem', color: maroon}}> Not all voters have cast their vote yet. Are you sure you want to close the election and generate the result? </Typography>
                            <Box style={{display: 'flex', justifyContent: 'flex-end', padding: '0.5rem', marginTop: '0.5rem'}}>
                                <Button style={{...buttonStyle, backgroundColor: '#D3D3D3', color: headingBlue}}
                                    onClick={() =>{
                                        setConfirmDialogStatus(() => false)
                                    }}
                                >Cancel</Button>
                                <Button style={buttonStyle}
                                    onClick={() => {
                                        handleGenerateResult()
                                    }}
                                > Confirm</Button>
                            </Box>
                        </DialogContent>
                    </Dialog>
                </>
            </DialogContent>

        </Dialog>
    </>
  )
}

export default ElectionResult
